import { z } from 'zod/mini'

import { amount, itemObject } from './fields'
import { itemShape } from './item'

/** Mobile plan fields: empty strings when the item has no mobile plan. */
export const mobilePlanShape = {
  item_mobile_plan_name: z.string(),
  item_mobile_plan_carrier: z.string(),
}

/** Insurance fields: `'none'` / `''` / `0` when the item has no insurance. */
export const insuranceShape = {
  item_insurance_name: z.string(),
  item_insurance_type: z.enum([
    'monthly',
    'one_time',
    'annually',
    'biannually',
    '',
  ]),
  item_insurance_price: amount(),
  item_insurance_currency: z.string(),
}

/** Per-item shipping fields: `''` / `0` when no shipping option is selected. */
export const itemShippingShape = {
  item_shipping_method: z.string(),
  item_shipping_cost: amount(),
}

/** Item keys of `view_cart`, base of every checkout funnel item. */
export const cartItemShape = {
  ...itemShape,
  ...mobilePlanShape,
  // Special offer type, empty for regular offers
  item_deal_type: z.string(),
  item_units_in_stock: z.number().check(z.gte(0)),
}

/** Item keys of `begin_checkout`. */
export const checkoutItemShape = {
  ...cartItemShape,
  ...insuranceShape,
  item_insurance_term_months: z.number().check(z.gte(0)),
}

export const cartItemSchema = itemObject(cartItemShape)

export const checkoutItemSchema = itemObject(checkoutItemShape)

/** Item of `add_shipping_info` and `add_payment_info`. */
export const checkoutItemWithShippingSchema = itemObject({
  ...checkoutItemShape,
  ...itemShippingShape,
})
